import { render, staticRenderFns } from "./SettingsEmailsTemplatesDeleteModal.vue?vue&type=template&id=59b93f3a&"
import script from "./SettingsEmailsTemplatesDeleteModal.vue?vue&type=script&lang=js&"
export * from "./SettingsEmailsTemplatesDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports